import React, { useState } from "react";
import "./ProductsPage.scss";
import { useStateValue } from "../context/StateProvider";
import CustomizerContainer from "./CustomizerContainer";
import ThemePicker from "./ThemePicker";
import { Link } from "react-router-dom";
import Button from "./LabelCustomizer/Button";
import { CloseCircleOutlined } from "@ant-design/icons";
// import SingleTemplateSelector from "./SingleTemplateSelector";
import { loadStripe } from "@stripe/stripe-js";


const stripeAPI =
  'pk_test_51H7M7AI6sOCxVA9BQG8sVwzMFZsy94Bc6losTQNPNEsqtqV8f3ZQcaw0ZPzHvHeKw5Z8KgEQsNTjnxqEV56GPALT00q0fDw114';

const stripe = loadStripe(stripeAPI)

const ProductsPage = () => {
 
  const [{ products }, dispatch] = useStateValue();
  const [isCustomizing, setCustomizing] = useState(false);
  const [isProductList, setProductList] = useState(true);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [useTemplate, setUseTemplate] = useState(null);


  

  const showCustomizer = (id) => {
    setCurrentProduct(id);
    setProductList(false);
    setCustomizing(true);
  };


  const goBack = () => {
    setCustomizing(false);
    setProductList(true);
  };

  const ProductList = () => {
    console.log('stripe', stripe)
    return (
      <main>
        <h2 className="page-title">Wines</h2>
        <div className="products-table">
          <div>
          </div>
          <section>
            <div className="products">
              {products.map((wine) => {
                return (
                  <section className="product" key={wine.id}>
                    <Link to={`/product/${wine.id}`}>
                      <img
                        className="product-image"
                        src={wine.image}
                        alt="wine"
                      />
                    </Link>

                    <div className="product-info">
                      <div>
                        <h2 className="product-title">{wine.name}</h2>
                      </div>
                      {/* <div className="price-tag">${wine.price}</div> */}
                      <div className="description">{wine.short}</div>
                      <button className="button is-outlined is-rounded" onClick={() => showCustomizer(wine.id)}>
                        Customize
                      </button>
                    </div>
                  </section>
                );
              })}
            </div>
          </section>
        </div>
      </main>
    );
  };

  return (
    <body>
      {isProductList && <ProductList />}
      
      {isCustomizing && (
        <CustomizerContainer
        setCustomizing={setCustomizing}
        setProductList={setProductList}
          productID={currentProduct}
          setCurrentProduct={setCurrentProduct}
          goBack={goBack}
          useTemplate={useTemplate}
          setUseTemplate={setUseTemplate}
        />
      )}
    </body>
  );
};

export default ProductsPage;
